module.exports = __webpack_public_path__ + "img/product-placeholder-27.8cb3756.png";